import { type CurrencyEnum, PriceIntervalEnum } from "@finway-group/shared/lib/models"
import { formatCurrencyNumber } from "@finway-group/shared/lib/utils"
import React from "react"
import { useTranslation } from "react-i18next"
import { Loading } from "~Components/loading"

interface PriceLabelProps {
    value: number
    currency: CurrencyEnum
    interval?: number
    isMonthly?: boolean
    showFullNumber?: boolean
    addPlusSign?: boolean
}

export const PriceLabel = ({ interval, currency, showFullNumber, value, addPlusSign }: PriceLabelProps) => {
    const { t } = useTranslation()

    if (!currency) {
        return <Loading />
    }
    return (
        <>
            {`${addPlusSign && value > 0 ? "+" : ""}${formatCurrencyNumber({ value, currency, showFullNumber })}`}
            {interval === PriceIntervalEnum.MONTHLY && ` / ${t("append:per_month")}`}
            {interval === PriceIntervalEnum.QUARTERLY && ` / ${t("append:per_quarter")}`}
            {interval === PriceIntervalEnum.YEARLY && ` / ${t("append:per_year")}`}
            {!interval && ""}
        </>
    )
}
